module.exports = __webpack_public_path__ + "media/new4.24902f2b.mp4";